import styled from 'styled-components'

/* Cap results area to ~75% of viewport minus the input header height */
export const GlobalSearchResultsListStyled = styled.div`
  max-height: calc(75vh - ${(props) => props.theme.typography.pxToRem(56)});
  overflow-y: auto;
`
